import { Injectable } from '@angular/core';
import { UpdatePointsTransferMembershipData } from '@features/membership/services/membership-api/membership-api.service';
import {
  CheckoutLinkedAccountPosition,
  LoyaltyProgramNameAttributes,
  TransferConnectV2SettingService,
} from '@features/transfer-connect-v2/services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';
import { LoyaltyProgram, SuccessButton, SuccessButtonGroup } from '@rd/types';

@Injectable({
  providedIn: 'root',
})
export class VmaTransferConnectV2SettingService extends TransferConnectV2SettingService {
  autoRedeemDateFormat = 'mediumDate';
  collapsibleTransferAmountForm = true;
  linkedAccountPosition: CheckoutLinkedAccountPosition = 'top';
  loyaltyProgramNameAttribute: LoyaltyProgramNameAttributes = 'shortName';
  shouldRenderCheckoutBanner = true;
  shouldRenderCheckoutBreadcrumb = false;
  shouldRenderReviewTnc = true;
  shouldRenderLinkAccountButtonIcon = true;

  /*
  ====================================
    Review page-only settings
  ====================================
  */

  getLoyaltyProgramDisplayName(
    updateMembershipData: UpdatePointsTransferMembershipData,
  ): string {
    return updateMembershipData.loyaltyProgramName ?? '';
  }

  formattedDestinationAmountName(loyaltyProgram: LoyaltyProgram): string {
    return loyaltyProgram?.loyaltyCurrency?.shortName ?? '';
  }

  successButtons(): SuccessButtonGroup {
    const makeAnotherRedemptionButton: SuccessButton = {
      buttonClass: 'full-width-on-mobile flips-on-mobile',
      buttonText: 'transfer_v2.success.make_another_redemption',
      buttonTheme: 'primary',
      redirectURL: '/redeem',
    };

    const toPointsTransactionButton: SuccessButton = {
      buttonClass: 'full-width-on-mobile flips-on-mobile',
      buttonText: 'transfer_v2.success.see_points_transaction',
      buttonTheme: 'secondary',
      redirectURL: '/points_activity',
    };

    return {
      confirmed: [toPointsTransactionButton, makeAnotherRedemptionButton],
      pending: [
        { ...makeAnotherRedemptionButton, buttonTheme: 'secondary' },
        { ...toPointsTransactionButton, buttonTheme: 'primary' },
      ],
      failed: [
        { ...makeAnotherRedemptionButton, buttonTheme: 'secondary' },
        { ...toPointsTransactionButton, buttonTheme: 'primary' },
      ],
    };
  }

  isPartnerVelocity(loyaltyProgram?: LoyaltyProgram): boolean {
    const { name, shortName } = loyaltyProgram ?? {};
    return !!(name?.includes('Velocity') || shortName?.includes('Velocity'));
  }
}
